'use client';

// imports
import NavLink from '@/components/Navigation/NavLink';

// styles
import styles from './MyListNav.module.scss';
const MyListNav = () => {
  return <ul className={styles.my_list_nav} data-sentry-component="MyListNav" data-sentry-source-file="MyListNav.tsx">
      <li><NavLink href="/my-list/shows/" className={styles.my_list_nav_link} data-sentry-element="NavLink" data-sentry-source-file="MyListNav.tsx">Shows</NavLink></li>
      <li><NavLink href="/my-list/videos/" className={styles.my_list_nav_link} data-sentry-element="NavLink" data-sentry-source-file="MyListNav.tsx">Videos</NavLink></li>
      <li><NavLink href="/my-list/continue-watching/" className={styles.my_list_nav_link} data-sentry-element="NavLink" data-sentry-source-file="MyListNav.tsx">Continue Watching</NavLink></li>
      <li><NavLink href="/my-list/viewing-history/" className={styles.my_list_nav_link} data-sentry-element="NavLink" data-sentry-source-file="MyListNav.tsx">Viewing History</NavLink></li>
    </ul>;
};
export default MyListNav;